import React from 'react';
import { Box } from '@mui/material';
import {
  getCapabilityLevelColor,
  normalizeCapabilityLevel,
} from '@utils/contestCatalog';

interface CapabilityLevelChipProps {
  level?: string | null;
  compact?: boolean;
}

const CapabilityLevelChip: React.FC<CapabilityLevelChipProps> = ({ level, compact = false }) => {
  const resolved = normalizeCapabilityLevel(level);
  const colors = getCapabilityLevelColor(resolved);
  return (
    <Box
      component="span"
      title={`Capability Level: ${resolved}`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: compact ? 0.6 : 0.85,
        py: compact ? 0.15 : 0.25,
        borderRadius: 999,
        bgcolor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
        fontWeight: 800,
        fontSize: compact ? { xs: '0.58rem', sm: '0.64rem' } : { xs: '0.68rem', sm: '0.74rem' },
        fontFamily: '"Sora", Arial, sans-serif',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        letterSpacing: 0.1,
        maxWidth: '100%',
      }}
    >
      {resolved}
    </Box>
  );
};

export default CapabilityLevelChip;
